import { useQuery } from '@apollo/client/react';
import type { AutomationKind } from '@insio/shared-types';
import { AutomationHelpDocument } from '@/graphql';

/** Help content of one AI automation — the modal and the side paper render the same data. */
export function useAutomationHelp(kind: AutomationKind) {
  const { data, loading, error } = useQuery(AutomationHelpDocument, {
    variables: { automation: kind }
  });

  return { help: data?.automationHelp, loading, error };
}
